<template>
  <div class="twoStar">
    <div class="imgbox">
      <img src="@/assets/twoStar/liangxin-top-bg.png" alt="" />
      <div class="content">
        <div
          class="item"
          v-for="(item, index) in menuList"
          :key="index"
          @click="goItem(item.name)"
        >
          <div class="top">
            <div class="left">
              <img src="@/assets/twoStar/liangxin-icon.png" alt="" />
              {{ item.title }}
            </div>
            <div class="right">立即进入</div>
          </div>
          <div class="banner">
            <img :src="item.src" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [
        {
          title: "财富中心综合党委",
          src: require("@/assets/index/dpsy-banner-djlm.png"),
          name: "综合党委",
        },
        {
          title: "华陆大厦综合党委",
          src: require("@/assets/twoStar/liangxin-banner2.png"),
          name: "华陆大厦综合党委",
        },
        {
          title: "东坡水街商圈综合党委",
          src: require("@/assets/twoStar/1.jpg"),
          name: "东坡水街商圈综合党委",
        },
      ],
    };
  },
  methods: {
    goItem(name) {
      let path;
      switch (name) {
        case "综合党委":
          path = "/partyAllience";
          break;
        case "华陆大厦综合党委":
          path = "/hualuParty";
          break;
        case "东坡水街商圈综合党委":
          path = "/dpCommerce";
          break;
      }
      if (path)
        this.$router.push({
          path,
          query: {
            title: name,
          },
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.twoStar {
  .imgbox {
    > img {
      width: 100%;
    }
    .content {
      .item {
        .top {
          .left {
            img {
              width: 0.5rem;
              height: 0.5rem;
              border-radius: 50%;
            }
            display: flex;
            align-items: center;
          }
          .right {
            font-size: 0.28rem;
            font-weight: 400;
            color: #999999;
          }
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.38rem;
        }
        .banner {
          img {
            width: 100%;
          }
        }
        width: 7.1rem;
        height: 3.68rem;
        background: #ffffff;
        border-radius: 0.24rem;
        padding: 0.46rem 0.36rem 0.49rem 0.33rem;
        margin-bottom: 0.26rem;
      }
      position: absolute;
      top: 5.71rem;
      width: 7.1rem;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 0.36rem;
      color: #333333;
    }
    position: relative;
  }
  padding-top: 1rem;
}
</style>